import MainService from "@/services/MainService.js";
import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios';
import msal from 'vue-msal'

Vue.use(VueAxios, axios)

Vue.use(msal, {
	auth: {
		clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
		tenantId: process.env.VUE_APP_MSAL_TENANT_ID,
		redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI
	}
});


export default {

	metaInfo: {
		// Configura los encabezados de respuesta para evitar la caché
		httpEquiv: {
		  'Cache-Control': 'no-store',
		  Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
		  Pragma: 'no-cache'
		}
	  },
	  
	name: 'LoginPage',
	data() {
		let ss = new MainService();
		return {
			ss: ss,
			loginRequest: {
				email: '',
                password: ''
			},
			loginRequestOffice: {},
			errorBag: {
				email: '',
                password: ''
			},
			auth:{},
			changePassword:{},
			showWelcomeModal: true,
			showChangePassword: false,
			showPasswordModal: false,
			loading: false,
			formShow: false,
			isSubmitting: false,  // Controlar si el botón fue presionado
            showError: false      // Controlar si el cuadro de error se muestra
			// title: process.env.VUE_APP_TITLE
		};

	},
	props: {
		msg: String
	},
	methods: {
		login() {
			this.isSubmitting = true;  // Marcar que el botón fue presionado
            this.showError = false;    // Ocultar cualquier error previo
            this.errorBag.password = '';  // Limpiar errores previos

			this.ss.login(this.loginRequest)
				.then(
					(result) => {
						console.log(result);
						localStorage.setItem('usuario', JSON.stringify(result.data.data));
						localStorage.setItem('token', JSON.stringify(result.data.token));

						// O si prefieres cambiarla a false
						//document.cookie = "clearLocalStorage=false; path=/; domain=.emi.edu.bo; max-age=3600"; // Establecerla como false
						

						this.$router.push('/stats');
						this.$router.go();
						// location.reload();

					}
				)
				.catch((error) => {
                    this.showError = true;  // Mostrar el cuadro de error

                    if (error.response && error.response.status === 401) {
                        this.errorBag.password = "Token o Correo incorrecto. Por favor, inténtelo nuevamente.";
                    } else if (error.response && error.response.data && error.response.data.errors) {
                        if (error.response.data.errors.password) {
                            const errorMsg = error.response.data.errors.password[0].replace('password', 'token');
                            this.errorBag.password = errorMsg;
                        }
                    } else {
                        this.errorBag.password = "Ocurrió un error inesperado. Intente más tarde.";
                    }
                });
		},

		showFormToken(){
			this.formShow = true;
		},

		openChagenPassword(){
			this.changePassword = {};
			this.showChangePassword = true;
			this.showError=false;
			this.errorBag.password=false;
		},

		closePasswordModal(){
			this.showPasswordModal = false;
		},
		closeChangePasswordModal(){
			this.showChangePassword = false;
			this.showError=false;
			this.errorBag.password=false;
		},
		sendChangePassword() {
			console.log("Correo enviado:", this.changePassword.email);
		
			if (!this.changePassword.email || this.changePassword.email.trim() === "") {
				this.errorBag.password = "Por favor, ingrese un correo electrónico válido.";
				this.showError = true;  // Mostrar el cuadro de error
				return;
			}
		
			this.ss.renovePassword(this.changePassword)
				.then((result) => {
					const response = result.data;
					if (response.success) {
						this.showChangePassword = false;
						this.showPasswordModal = true;
						this.formShow = true;
						this.loginRequest.email = this.changePassword.email;
					} else {
						this.errorBag.password = response.msg || "Error al enviar el token. Verifique el correo ingresado.";
						this.showError = true;
					}
				})
				.catch((error) => {
					this.showError = true;  // Mostrar el cuadro de error
		
					if (error.response && error.response.status === 401) {
						this.errorBag.password = "Correo incorrecto. Por favor, inténtelo nuevamente.";
					} else if (error.response && error.response.status === 404) {
						this.errorBag.password = "Correo electrónico no encontrado. Verifique el correo ingresado.";
					} else if (error.response && error.response.data && error.response.data.errors) {
						if (error.response.data.errors.email) {
							this.errorBag.password = error.response.data.errors.email[0];
						}
					} else {
						this.errorBag.password = "Ocurrió un error inesperado. Intente nuevamente.";
					}
				});
		}
		
		,

		authenticate() {
			// console.log("login")
			// console.log("office",this.$msal.isAuthenticated());

			if(this.$msal.isAuthenticated() == false){
				// console.log("no esta autenticado en office")
				this.$msal.signIn();
				this.loginRequestOffice={};


			}


			if (this.$msal.isAuthenticated() == true) {
				this.loginRequestOffice={};
				// console.log("Esta autenticado en office")

				// console.log(this.$msal.data);
				// let loginTokenRequest = {
				// 	"token": this.$msal.data.user.accountIdentifier,
				// 	"email": this.$msal.data.user.userName,
				// };
				 this.loginRequestOffice.token=this.$msal.data.user.accountIdentifier;
				 this.loginRequestOffice.email=this.$msal.data.user.userName;

				// console.log("datos login",loginTokenRequest)

				// this.ss.loginToken365(loginTokenRequest)
				this.ss.loginToken365(this.loginRequestOffice)
				.then(
					(result) => {
						// console.log("resultado controlador login 365",result);

						localStorage.setItem('usuario', JSON.stringify(result.data.data));
						localStorage.setItem('token', JSON.stringify(result.data.token));
						

						this.$router.push('/stats');
						// location.reload();

						this.$router.go();

						// localStorage.setItem('usuario', JSON.stringify(result.data.data));
						// localStorage.setItem('token', JSON.stringify(result.data.token));
						

						// this.$router.push('/stats');
						// this.$router.go();
						// // location.reload();

					}
				)
				/*.catch((error) => {
					this.errorBag = error.response.data.errors;
					this.$bvToast.toast(
						'Problema al Iniciar Sesion',
						{
							title: 'Error',
							variant: 'danger',
							autoHideDelay: -1
						}
					)

					this.$msal.signOut();

				});*/





				// this.ss.loginToken365(loginTokenRequest)
				// 	.then(
				// 		(result) => {
				// 			console.log("ingresar");
	
				// 			console.log(result);
				// 			localStorage.setItem('persona', JSON.stringify(result.data.data));
				// 			localStorage.setItem('token', JSON.stringify(result.data.token));
				// 			this.$router.push('/stats');
				// 			this.$router.go();
				// 			// location.reload();
				// 			console.log("exitoso");
				// 		}
				// 	)
				// 	.catch((error) => {
					// 	this.errorBag = error.response.data.errors;
					// 	this.$bvToast.toast(
					// 		'Problema al Iniciar Sesion',
					// 		{
					// 			title: 'Error',
					// 			variant: 'danger',
					// 			autoHideDelay: 5000
					// 		}
					// 	)
					// 	// this.$msal.signOut();
					// });
			} 



			// if (!this.$msal.isAuthenticated()) {
			// 	// console.log("office 2",this.$msal.signIn());

			// 	this.$msal.signIn();
			// }
		},

		closeModal() {
			// Al hacer clic en el botón, ocultamos el modal
			this.showWelcomeModal = false;
			document.cookie = "cursos_session=; path=/; domain=.emi.edu.bo; max-age=3600";
		},

		
	},

	mounted() {
		localStorage.clear();

		// var persona = JSON.parse(localStorage.getItem('persona'));
		// if (persona) {
		// 	localStorage.clear();
		// }
		// if (this.$msal.isAuthenticated()) {
		// 	console.log(this.$msal.data);
		// 	let loginTokenRequest = {
		// 		"token": this.$msal.data.user.accountIdentifier,
		// 		"email": this.$msal.data.user.userName,
		// 	};
		// 	this.ss.loginToken365(loginTokenRequest)
		// 		.then(
		// 			(result) => {
		// 				console.log("ingresar");

		// 				console.log(result);
		// 				localStorage.setItem('persona', JSON.stringify(result.data.data));
		// 				localStorage.setItem('token', JSON.stringify(result.data.token));
		// 				this.$router.push('/stats');
		// 				this.$router.go();
		// 				// location.reload();
		// 				console.log("exitoso");
		// 			}
		// 		)
		// 		.catch((error) => {
		// 			this.errorBag = error.response.data.errors;
		// 			this.$bvToast.toast(
		// 				'Problema al Iniciar Sesion',
		// 				{
		// 					title: 'Error',
		// 					variant: 'danger',
		// 					autoHideDelay: 5000
		// 				}
		// 			)
		// 			// this.$msal.signOut();
		// 		});
		// } else {
		// 	console.log("no esta logeeado")
		// }
	}

}